import Swiper from 'swiper';

const BlogGallery = () => {
  /* !----------------- SWIPER ------------------! */
  const containers = document.querySelectorAll('.blog-section-gallery .swiper-container');

  if (!containers.length) return;

  containers.forEach(container => {
    // get the id of the swiper, or its closest unique id
    const gallerySection = container.closest('.blog-section-gallery');
    const id = gallerySection?.id;

    new Swiper(container, {
      loop: false,
      spaceBetween: 10,
      slidesPerView: 1,
      navigation: {
        nextEl: `#${id} .swiper-button-next`,
        prevEl: `#${id} .swiper-button-prev`,
      },
    });
  });
};

export default BlogGallery;